(()=>{
const root=document.getElementById('ptw-weggie');
if(!root)return;
const log=root.querySelector('.weggie-messages'),choices=root.querySelector('.weggie-choices'),dataEl=root.querySelector('[data-weggie-text]');
if(!log||!choices||!dataEl)return;
let t;try{t=JSON.parse(dataEl.textContent)}catch(e){return}
const tips=[
{text:'Verstop kleine figuurtjes in speelrijst en laat je kind ze opgraven. Benoem samen wat het vindt.',q:'speelrijst'},
{text:'Vul een vulvorm met rijst of kikkererwten en schud eens. Hoor je het verschil tussen zacht en luid?',q:'vulvormen'},
{text:'Sorteer loose parts op kleur, vorm of grootte. Laat je kind zelf bedenken hoe.',q:'loose parts'},
{text:'Rol een roller door kinetisch zand of klei en kijk welke sporen er ontstaan.',q:'rollers'},
{text:'Verzin samen een verhaal met de speelfiguurtjes. Wie krijgt de hoofdrol?',q:'speelset'},
{text:'Tel samen de loose parts en leg ze in rijen. Welke rij is het langst?',q:'tellen'},
{text:'Ga op herfstwandeling, verzamel blaadjes en leg thuis dezelfde vormen na op tafel.',q:'herfst'},
{text:'Laat je kind met een zeefje door rijst scheppen. Wat blijft hangen en wat valt erdoor?',q:'zeefjes'},
{text:'Maak een gezichtje bij elke emotie. Welk gevoel past bij vandaag?',q:'emoties'},
{text:'Speel winkeltje met een bakje en wat loose parts. Jij bent de klant!',q:'eten'},
{text:'Stempel in zand of klei en raad welke afdruk bij welke stempel hoort.',q:'stempels'},
{text:'Kijk samen naar buiten en kies het weer van vandaag met de weerkijker.',q:'weerkijker'},
{text:'Geef je kind twee bakjes en een lepeltje om over te scheppen. Een leuke oefening voor de fijne motoriek.',q:'motoriek'},
{text:'Laat je kind de ogen sluiten en raden wat je in zijn hand stopt.',q:'sensorisch'}
];
let offset=0;
function pick(){return tips[(Math.floor(Date.now()/864e5)+offset)%tips.length]}
function say(text,isUser){
const box=document.createElement('div');box.className='weggie-message'+(isUser?' weggie-message-user':'');box.dataset.tip='1';
const name=document.createElement('strong');name.textContent=isUser?t.you:t.bot;
const p=document.createElement('p');p.textContent=text;box.append(name,p);log.append(box);log.scrollTop=log.scrollHeight;return box;
}
function fill(box,tip,label){
const p=box.querySelector('p');p.textContent=label+tip.text;
if(!box.querySelector('.weggie-link')){const a=document.createElement('a');a.className='weggie-link';a.textContent=t.search_more;a.href=new URL(root.dataset.search+'?type=product&q='+encodeURIComponent(tip.q),location.origin).href;box.append(a)}
}
function addMoreButton(){
if(choices.querySelector('[data-more-tip]'))return;
const b=document.createElement('button');b.type='button';b.dataset.moreTip='1';b.textContent='Nog een tip';
b.addEventListener('click',()=>{offset++;const box=say('');fill(box,pick(),'Nog een tip: ');log.scrollTop=log.scrollHeight});
if(choices.firstElementChild)choices.firstElementChild.after(b);else choices.append(b);
}
new MutationObserver(list=>{
for(const m of list){for(const n of m.addedNodes){
if(!(n instanceof HTMLElement)||!n.classList.contains('weggie-message')||n.classList.contains('weggie-message-user')||n.dataset.tip)continue;
const p=n.querySelector('p');
if(p&&p.textContent===t.tip_text){n.dataset.tip='1';offset=0;fill(n,pick(),'Speeltip van de dag: ');addMoreButton();log.scrollTop=log.scrollHeight}
}}
}).observe(log,{childList:true});

const THEMES=[['Vogels','vogels'],['Voertuigen','voertuigen'],['Dinosaurus','dinosaurus'],['Circus en kermis','circus-en-kermis'],['Bijen','bijen'],['Boerderij','boerderij'],['Fruit & groenten','fruit-en-groenten'],['Herfst','herfst'],['Ijsjes','ijsjes'],['Kunst','kunst'],['Onderwaterwereld','onderwaterwereld']];
let saved=null;const store={};
function setChoices(items){choices.replaceChildren();for(const [label,fn] of items){const b=document.createElement('button');b.type='button';b.textContent=label;b.dataset.browse='1';b.addEventListener('click',fn);choices.append(b)}}
function snapshot(){saved=[...choices.children]}
function back(){if(saved)choices.replaceChildren(...saved)}
function browseMenu(){setChoices([['Nieuwe producten',()=>go('Nieuwe producten','nieuwe-producten')],['Loose parts',()=>go('Loose parts','loose-parts')],['Alle thema’s',()=>{say('Alle thema’s',true);themes()}],['Alle producten',()=>go('Alle producten','all')],['Terug naar start',back]])}
function enterBrowse(){snapshot();say('Bekijk de shop',true);say('Wat wil je zien?');browseMenu()}
function themes(){say('Kies een thema:');setChoices([...THEMES.map(([l,h])=>[l,()=>go(l,h)]),['Terug',browseMenu],['Terug naar start',back]])}
async function go(label,handle){
say(label,true);const box=say('Even zoeken...');setChoices([]);
try{
if(!store[handle]){
const url=new URL(root.dataset.root+'collections/'+handle+'/products.json',location.origin);url.searchParams.set('limit','250');
const r=await fetch(url);if(!r.ok)throw new Error('collection');
const d=await r.json();store[handle]=d.products||[];
}
show(box,label,handle,0);
}catch(e){
box.querySelector('p').textContent='Dat lukt nu even niet. Bekijk anders de hele shop.';
const a=document.createElement('a');a.className='weggie-link';a.textContent=t.all;a.href=new URL(root.dataset.root+'collections/all',location.origin).href;box.append(a);
setChoices([['Andere keuze',browseMenu],['Terug naar start',back]]);
}
}
function show(box,label,handle,start){
const items=store[handle];const page=items.slice(start,start+6);
box.querySelector('p').textContent=items.length?(start?'Nog meer uit '+label+':':label+' ('+items.length+' producten):'):'Hier staat nog niks in.';
const fmt=new Intl.NumberFormat(document.documentElement.lang||'nl-BE',{style:'currency',currency:'EUR'});
for(const p of page){
const a=document.createElement('a');a.className='weggie-product';a.href=new URL(root.dataset.root+'products/'+p.handle,location.origin).href;
const img=p.images&&p.images[0]&&p.images[0].src;
if(img){const src=new URL(img);if(src.protocol==='https:'){src.searchParams.set('width','120');const i=document.createElement('img');i.src=src.href;i.alt='';i.width=52;i.height=52;i.loading='lazy';a.append(i)}}
const prices=p.variants.map(v=>Number(v.price));
const span=document.createElement('span');span.textContent=p.title+' · '+fmt.format(Math.min(...prices));a.append(span);box.append(a);
}
const btns=[];
if(start+6<items.length)btns.push(['Toon meer',()=>{show(say(''),label,handle,start+6)}]);
btns.push(['Andere keuze',browseMenu],['Terug naar start',back]);
setChoices(btns);log.scrollTop=log.scrollHeight;
}
new MutationObserver(()=>{
const first=choices.firstElementChild;
if(!first||first.dataset.browse||first.textContent!==t.start_choice||choices.querySelector('[data-browse]'))return;
const b=document.createElement('button');b.type='button';b.dataset.browse='1';b.textContent='Bekijk de shop';b.addEventListener('click',enterBrowse);first.after(b);
}).observe(choices,{childList:true});
choices.addEventListener('click',e=>{
const b=e.target.closest('button');
if(!b||b.dataset.browse||b.dataset.moreTip)return;
if(b.textContent===t.themes){e.stopPropagation();snapshot();say(t.themes,true);themes()}
},true);

const jokes=['Waarom nam de vos een ladder mee naar de speelzaal? Hij hoorde dat het daar hoog aan toe ging!','Wat zei de rijst tegen de speelpot? Wat is het hier druk!','Waarom is de speelboom nooit alleen? Hij heeft altijd een blaadje om mee te kletsen.','Wat is oranje, pluizig en helpt je kiezen? Ik! Weggie de vos!'];
let jokeIndex=Math.floor(Math.random()*jokes.length);
const form=root.querySelector('form'),input=root.querySelector('input');
if(form&&input)form.addEventListener('submit',e=>{
const v=input.value;
if(!/(grap|mop|joke|lachen)/i.test(v))return;
e.preventDefault();e.stopImmediatePropagation();
say(v.slice(0,160),true);input.value='';
say(jokes[jokeIndex++%jokes.length]);
},true);

const mainEl=document.getElementById('MainContent');
const tpl=((mainEl&&mainEl.dataset)||{}).template||'';
const bubbles=[['product','Twijfel je? Ik help je kiezen!'],['cart','Is het een cadeautje? Ik denk graag mee!'],['search','Niks gevonden? Vraag het mij!'],['404','Oeps! Ik zoek de weg voor je.'],['page.b2b','Vragen voor je klas of praktijk? Vraag het mij!'],['page.cadeautips','Zoek je een cadeautje? Ik help je!'],['collection','Zoek je iets specifieks? Ik help je!'],['list-collections','Zoek je iets specifieks? Ik help je!']];
const hit=bubbles.find(([k])=>tpl===k||tpl.startsWith(k+'.'));
if(hit){
const els=[root.querySelector('.weggie-cta-desktop'),root.querySelector('.weggie-cta-mobile')].filter(Boolean);
const apply=()=>{for(const el of els){if(el.textContent===t.cta_desktop||el.textContent===t.cta_mobile)el.textContent=hit[1]}};
apply();
const obs=new MutationObserver(apply);
for(const el of els)obs.observe(el,{childList:true,characterData:true,subtree:true});
}

function weggieBlock(title,text){
if(!mainEl||mainEl.querySelector('[data-weggie-block]'))return;
const box=document.createElement('div');box.dataset.weggieBlock='1';
box.style.cssText='display:flex;flex-direction:column;align-items:center;text-align:center;gap:10px;padding:32px 20px;max-width:520px;margin:0 auto';
const img=document.createElement('img');
img.src=matchMedia('(prefers-reduced-motion: reduce)').matches?root.dataset.still:root.dataset.wave;
img.alt='';img.width=150;img.height=163;img.style.cssText='width:150px;height:auto';
const h=document.createElement('p');h.textContent=title;h.style.cssText='font-family:Fredoka,sans-serif;font-size:24px;font-weight:600;color:#315d49;margin:0';
const p=document.createElement('p');p.textContent=text;p.style.cssText='margin:0;color:#263c32';
const b=document.createElement('button');b.type='button';b.textContent='Praat met Weggie';
b.style.cssText='background:#315d49;color:#fff;border:0;border-radius:20px;padding:12px 20px;font-size:16px;cursor:pointer';
b.addEventListener('click',()=>{root.hidden=false;const l=root.querySelector('.weggie-launcher');if(l&&l.getAttribute('aria-expanded')!=='true')l.click()});
box.append(img,h,p,b);mainEl.prepend(box);
}
if(tpl==='404'){
weggieBlock('Oeps, hier is niks!','Deze pagina bestaat niet. Ik help je graag verder zoeken.');
}else if(tpl==='cart'){
fetch('/cart.js').then(r=>r.json()).then(c=>{if(c&&c.item_count===0)weggieBlock('Je winkelmandje is nog leeg','Zal ik je helpen kiezen? Vertel me de leeftijd van je kind en ik zoek iets leuks.')}).catch(()=>{});
}else if(tpl==='search'){
const q=new URLSearchParams(location.search).get('q');
if(q&&mainEl&&!mainEl.querySelector('a[href*="/products/"]'))weggieBlock('Niks gevonden','Probeer een ander woord, of vraag het aan mij. Ik ken al het speelgoed.');
}
})();
